import { AuthRepository } from '@app/core/repositories/auth.repository';
import { Observable, of } from 'rxjs';

export class FakeAuthRepository implements AuthRepository {
  logout(): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(true);
  }
}
